import script from "./MisHorarios.vue?vue&type=script&setup=true&lang=js"
export * from "./MisHorarios.vue?vue&type=script&setup=true&lang=js"

import "./MisHorarios.vue?vue&type=style&index=0&id=2e7be648&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e7be648"]])

export default __exports__